import { OrderingInitialState, SetEditCustomerModalAction } from '@reducers/ordering/types';

export const setEditCustomerModal = (
  state: OrderingInitialState,
  action: SetEditCustomerModalAction
): OrderingInitialState => ({
  ...state,
  customerState: {
    ...state.customerState,
    displayEditCustomerModal: action.payload,
  },
});
